<template>
    <div @dragenter="ondragenter" style="height:100%;">
        <div v-if="drop_visible" class="overflow" :style="'width:' + drop_width + 'px;' + 'height:' + drop_height + 'px;'"
            @dragenter="ondragenter" @dragover="ondragover" @dragleave="ondragleave" @drop="ondrop">
            <slot name="overflow">
                {{ $tr("Перемещённые файлы будут сразу загружены в эту папку") }}
            </slot>
        </div>
        <slot name="default"></slot>
    </div>
</template>

<script>
export default {
    name: 'DropZone',
    data() {
        return {
            drop_width: 0,
            drop_height: 0,
            drop_visible: false,
        };
    },
    methods: {
        update_layout() {
            this.$nextTick(() => {
                const el = this.$el;
                if (el != null) {
                    this.drop_width = el.clientWidth;
                    this.drop_height = el.clientHeight;
                }
            });
        },
        ondragenter(ev) {
            this.update_layout();
            this.drop_visible = true;
            ev.stopPropagation();
            ev.preventDefault();
        },
        ondragleave(ev) {
            this.drop_visible = false;
            ev.stopPropagation();
            ev.preventDefault();
        },
        ondragover(ev) {
            ev.stopPropagation();
            ev.preventDefault();
        },
        async ondrop(ev) {
            this.drop_visible = false;
            ev.stopPropagation();
            ev.preventDefault();
            const files = [];
            let items = ev.dataTransfer.items;
            if (items != null) {
                const transfered = [];
                for (let i = 0; i < items.length; i += 1) {
                    transfered.push(items[i]);
                }
                for (let i = 0; i < transfered.length; i += 1) {
                    const item = transfered[i];
                    transfered[i] = this.get_transfered_files(item, files);
                }
                Promise.all(transfered)
                    .then(() => {
                        this.$emit('drop', files);
                    });
            } else {
                items = ev.dataTransfer.files;
                if (items != null) {
                    for (let i = 0; i < items.length; i += 1) {
                        const file = items[i];
                        if (file != null) {
                            files.push(file);
                        }
                    }
                }
                this.$emit('drop', files);
            }
        },
        get_transfered_files(item, files) {
            return new Promise((resolve, reject) => {
                if (item.kind === 'file') {
                    if (item.webkitGetAsEntry != null) {
                        this.scan_files(item.webkitGetAsEntry(), files)
                            .then(resolve)
                            .catch(reject);
                    } else {
                        const file = item.getAsFile();
                        if (file != null) {
                            files.push(file);
                            resolve();
                        }
                    }
                }
            });
        },
        scan_files(item, files) {
            return new Promise((resolve) => {
                if (item == null) {
                    return;
                }
                if (item.isDirectory) {
                    this.read_folder(item)
                        .then((entries) => {
                            if (entries.length === 0) {
                                let fullPath = item.fullPath;
                                if ((fullPath != null) && (fullPath.length > 0)) {
                                    if (fullPath[0] === '/') {
                                        fullPath = fullPath.substring(1);
                                    }
                                }
                                files.push({
                                    ...item,
                                    fullPath,
                                });
                                resolve();
                            } else {
                                const promises = [];
                                for (let i = 0; i < entries.length; i += 1) {
                                    promises.push(this.scan_files(entries[i], files));
                                }
                                Promise.all(promises)
                                    .then(resolve)
                                    .catch(resolve);
                            }
                        })
                        .catch(resolve);
                } else if (item.isFile) {
                    this.read_file(item)
                        .then((file) => {
                            if (file != null) {
                                let fullPath = item.fullPath;
                                if ((fullPath != null) && (fullPath.length > 0)) {
                                    if (fullPath[0] === '/') {
                                        fullPath = fullPath.substring(1);
                                    }
                                }
                                file.fullPath = fullPath;
                                files.push(file);
                                resolve();
                            }
                        })
                        .catch(resolve);
                }
            });
        },
        read_folder(entry) {
            return new Promise((resolve, reject) => {
                const result = [];
                const reader = entry.createReader();
                const batch = () => {
                    reader.readEntries((entries) => {
                        if (entries.length > 0) {
                            entries.forEach((e) => result.push(e));
                            batch();
                        } else {
                            resolve(result);
                        }
                    }, reject);
                };
                batch();
            });
        },
        read_file(entry) {
            return new Promise((resolve, reject) => {
                entry.file(resolve, reject);
            });
        },
    },
};
</script>

<style scoped>
.overflow {
    position: absolute;
    background: rgba(var(--v-theme-primary), 0.3);
    border: 2px solid rgb(var(--v-theme-primary));
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 1000;
}
</style>
